// extracted by mini-css-extract-plugin
export default {"listImageBackgroundColor":"_1nfcl","square":"_2xaAq"};